import ConstructedStyleSheet from './ConstructedStyleSheet';
import {attachAdoptedStyleSheetPropertyToInstance} from './Location';

export type {ConstructedStyleSheet};
export {attachAdoptedStyleSheetPropertyToInstance};

const isCSSStyleSheetConstructorSupported = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const CSSStylesheet = new CSSStyleSheet();
    return true;
  } catch (error) {
    return false;
  }
};

export const shouldUseNativeAdoptedStylesheets = () => {
  // Firefox has issues with adoptedStylesheets and triggering repaints in different shadow DOMs, so we fall back to our polyfill
  // Also applies to Safari < 15.6, which doesn't support the CSSStyleSheet constructor
  return (
    'adoptedStyleSheets' in document && isCSSStyleSheetConstructorSupported()
  );
};

export function getCSSStyleSheetClass() {
  if (shouldUseNativeAdoptedStylesheets()) {
    return CSSStyleSheet;
  } else {
    return ConstructedStyleSheet;
  }
}

export function getCSSConstructor(sheetName: string | undefined) {
  if (shouldUseNativeAdoptedStylesheets()) {
    return new CSSStyleSheet();
  } else {
    return new ConstructedStyleSheet(sheetName);
  }
}

export function getAdoptedStyleSheetApplier() {
  if (shouldUseNativeAdoptedStylesheets()) {
    return () => {};
  } else {
    return attachAdoptedStyleSheetPropertyToInstance;
  }
}
